module.exports = __webpack_public_path__ + "img/sa.5c9acf20.png";